
import React, { FC } from 'react';

import {
    Row,
    Spacer,
    Text
} from '@components/1-atoms';

import {
    DrawerItem,
    PlayBookDrawerLogo,
    DrawerCloseButton,
} from '@components/2-molecules';

import Dashboard from '@assets/icons/drawer/dashoard';

import Documents from '@assets/icons/drawer/documents';
// import Documents from '@assets/icons/drawer/expenses';

import Contacts from '@assets/icons/drawer/contacts';

import Products from '@assets/icons/drawer/products';
import Charts from '@assets/icons/drawer/chart';
import Profit from '@assets/icons/drawer/profit';
import Balance from '@assets/icons/drawer/balance';

import General from '@assets/icons/drawer/general';
import Tax from '@assets/icons/drawer/tax';

import styled, { css } from '@emotion/native';
import { logout } from '@lib/service';

const Container = styled.ScrollView` padding-left: 18px; `;



const Drawer: FC<Props> = ({ navigation, ...props }) => {

    return (
        <Container>
            <Spacer h={3.5} />

            <Row style={css`justify-content: center; align-items: center;`}>
                <PlayBookDrawerLogo onPress={() => navigation?.navigate('Dashboard')} />
                <Spacer w={1} />
                <DrawerCloseButton onPress={navigation?.toggleDrawer} />
            </Row>
            <Spacer h={4} />
            

            {/* DASHBOARD MENU ITEM */}
            <DrawerItem onPress={() => navigation?.navigate('Dashboard')} align={"left"} left={<Dashboard />}>
                <Text color={"#434BFF"}>Dashboard {`\n`}
                    <Text xsmall>Todos and insights</Text>
                </Text>
            </DrawerItem>
            <Spacer h={3} />

            {/* BUSINESS DOCUMENTS */}
            <Row><Text xsmall color={"#C4C4C4"}>BUSINESS</Text></Row>
            <Spacer h={0.3} />
            <DrawerItem onPress={() => navigation?.navigate('Documents')} align={"left"} left={<Documents />}>
                <Text color={"#434BFF"}>
                    Documents {`\n`}
                    <Text xsmall>Estimates, invoices, receipts, ...</Text>
                </Text>
            </DrawerItem>
            <Spacer h={3} />

            {/* REPORTS AND BUSINESS */}
            <Row><Text xsmall color={"#C4C4C4"}>CONTACTS AND ACCOUNTING</Text></Row>
            <Spacer h={0.3} />
            <DrawerItem onPress={() => navigation?.navigate('Contacts')} align={"left"} left={<Contacts />}>
                <Text color={"#434BFF"}>Contacts {`\n`}
                    <Text xsmall>Customers and vendors</Text>
                </Text>
            </DrawerItem>
            <DrawerItem onPress={() => navigation?.navigate('ProductsServices')} align={"left"} left={<Products />}>
                <Text color={"#434BFF"}>Items {`\n`}
                    <Text xsmall>Goods and services</Text></Text>
            </DrawerItem>
            <DrawerItem onPress={() => navigation?.navigate('ChartOfAccounts')} align={"left"} left={<Charts />}>
                <Text color={"#434BFF"}>Accounts{'\n'}and Patrimonies {`\n`}
                    <Text xsmall>Categories, banks and cash</Text></Text>
            </DrawerItem>
            {/* <DrawerItem onPress={() => navigation?.navigate('StatementIncome')} align={"left"} left={<Profit />}>
                <Text color={"#434BFF"}>Profit & Loss {`\n`}
                    <Text xsmall>Delta of incomes - expenses</Text></Text>
            </DrawerItem> */}
            {/* <DrawerItem onPress={() => navigation?.navigate('StatementBalanceSheet')} align={"left"} left={<Balance />}>
                <Text color={"#434BFF"}>Balance Sheet {`\n`}
                    <Text xsmall>Daily account balances</Text></Text>
            </DrawerItem> */}
            <Spacer h={3} />

            {/* MORE */}
            <Row><Text xsmall color={"#C4C4C4"}>MORE</Text></Row>
            <Spacer h={0.3} />
            <DrawerItem onPress={() => navigation?.navigate('Taxes')} align={"left"} left={<Tax />}>
                <Text color={"#434BFF"}>Taxes {`\n`}
                    <Text xsmall>Compulsory contribution to authorities</Text></Text>
            </DrawerItem>
            <DrawerItem onPress={() => navigation?.navigate('More')} align={"left"} left={<General />}>
                <Text color={"#434BFF"}>More {`\n`}
                    <Text xsmall>Everything else</Text></Text>
            </DrawerItem>
            <Spacer h={3} />

            <DrawerItem onPress={() => { logout() }} align={"left"}>
                <Text color={"#EB5757"}>Logout</Text>
            </DrawerItem>
            <Spacer h={3} />
        </Container>
    );
};

type Props = { navigation?: any; }

export default Drawer;